import React, { useContext } from 'react';
import {
  Route, RouteProps,
} from 'react-router-dom';
import config from '../configs';
import { AuthenticationContext } from '../contexts/Authentication';
import { encodeRedirect } from '../utils/url';

export default function UnauthRoute({
  location,
  component,
  render,
  children,
  path,
  exact,
  sensitive,
  strict,
}: RouteProps) {
  const { state: { authenticated, userData } } = useContext(AuthenticationContext);

  if (authenticated && userData?.emailVerified) {
    // NOTE: Old post login redirect, code is still available
    // return <Redirect to="/authenticated" />;
    window.location.href = encodeRedirect() || config.companyMarketplaceURL;
  }

  return (
    <Route
      location={location}
      component={component}
      render={render}
      path={path}
      exact={exact}
      sensitive={sensitive}
      strict={strict}
    >
      {children}
    </Route>
  );
}
